import React from "react"
import PropTypes from "prop-types"
import styles from "./browserScreenWithIPhone.module.css"
import MobileFrame from "./mobileFrame"

export default function BrowserScreenWithIPhone({
  className,
  browserImageURL,
  phoneContent,
}) {
  return (
    <div className={`${styles.container} ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        enableBackground="new"
        viewBox="0 0 1138.4 793.46"
        className={styles.browser}
      >
        <rect
          width="1136"
          height="714.58"
          fill="#fff"
          fillOpacity="0.004"
          rx="8"
          ry="8"
        ></rect>
        <g filter="url(#lasdnjkw-a)" transform="translate(-59 -32)">
          <rect
            width="1136"
            height="697.6"
            x="59"
            y="32"
            fill="#c4c4c4"
            rx="9"
          ></rect>
        </g>
        <image
          width="1136"
          height="674.08"
          y="40.499"
          href={
            browserImageURL ||
            "https://static9.depositphotos.com/1594308/1110/i/600/depositphotos_11107478-stock-photo-fantasy.jpg"
          }
          imageRendering="optimizeQuality"
          preserveAspectRatio="none"
        ></image>
        <path
          fill="#fff"
          d="M0 9a9 9 0 019-9h1118a9 9 0 019 9v31.499H0z"
        ></path>
        <circle
          cx="28.856"
          cy="20.756"
          r="6.081"
          fill="#ff6359"
          stroke="#fa463a"
        ></circle>
        <circle
          cx="50.118"
          cy="20.756"
          r="6.081"
          fill="#f7bf2b"
          stroke="#e9b11e"
        ></circle>
        <circle
          cx="71.379"
          cy="20.756"
          r="6.081"
          fill="#34c546"
          stroke="#24ba36"
        ></circle>
        <g stroke="#878787">
          <path
            strokeWidth="1.3"
            d="M112.02 16.175c0-.746.604-1.35 1.35-1.35h12.199c.746 0 1.35.604 1.35 1.35v9.162a1.35 1.35 0 01-1.35 1.35H113.37a1.35 1.35 0 01-1.35-1.35zM113.4 17.212h2.532m-2.532 2.025h2.532m-2.532 2.025h2.532m1.518-6.075v11.137"
          ></path>
          <g strokeLinejoin="round">
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M164.53 15.187l-5.569 5.569 5.569 5.568"
            ></path>
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M185.28 15.187l5.569 5.569-5.569 5.568"
              opacity="0.5"
            ></path>
            <path
              strokeWidth="1.3"
              d="M315.24 15.96l-4.91-1.786v13.163l4.835-3.956a2 2 0 00.733-1.548V16.9a1 1 0 00-.658-.94z"
            ></path>
          </g>
        </g>
        <g strokeWidth="1.3">
          <path
            fill="#878787"
            stroke="#807d7d"
            strokeLinejoin="round"
            d="M305.41 15.96l4.911-1.786v13.163l-4.835-3.956a1.998 1.998 0 01-.734-1.548V16.9a1 1 0 01.658-.94z"
          ></path>
          <rect
            width="453.59"
            height="22.274"
            x="339.18"
            y="9.112"
            fill="#f2f2f2"
            stroke="#eaeaea"
            rx="4"
          ></rect>
          <path
            stroke="#878787"
            strokeLinecap="round"
            d="M785.68 20.756a5.062 5.062 0 11-5.062-5.062h2.025"
          ></path>
          <path
            stroke="#878787"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M780.62 13.162l2.531 2.531-2.531 2.531"
          ></path>
        </g>
        <path
          fill="#878787"
          d="M531.15 25.271c.882 0 1.657-.457 2.044-1.174h.025v1.053h1.378v-4.602c0-1.339-1.035-2.202-2.666-2.202-1.644 0-2.641.882-2.736 2.031l-.007.07h1.295l.013-.057c.114-.533.603-.908 1.396-.908.851 0 1.327.444 1.327 1.18v.502l-1.815.108c-1.581.095-2.482.806-2.482 1.968v.013c0 1.2.895 2.018 2.228 2.018zm-.844-2.05v-.013c0-.565.457-.927 1.282-.977l1.631-.102v.52c0 .87-.73 1.524-1.695 1.524-.736 0-1.218-.368-1.218-.952zm6.144 4.151h1.371v-3.345h.031c.394.774 1.162 1.257 2.108 1.257 1.676 0 2.774-1.34 2.774-3.466v-.006c0-2.133-1.092-3.466-2.793-3.466-.952 0-1.689.482-2.089 1.276h-.031v-1.15h-1.371zm3.135-3.269c-1.034 0-1.771-.901-1.771-2.285v-.006c0-1.39.73-2.292 1.771-2.292 1.073 0 1.752.87 1.752 2.292v.006c0 1.41-.673 2.285-1.752 2.285zm4.735 3.27h1.371v-3.346h.032c.394.774 1.162 1.257 2.107 1.257 1.676 0 2.774-1.34 2.774-3.466v-.006c0-2.133-1.091-3.466-2.793-3.466-.952 0-1.688.482-2.088 1.276h-.032v-1.15h-1.371zm3.136-3.27c-1.035 0-1.771-.901-1.771-2.285v-.006c0-1.39.73-2.292 1.771-2.292 1.073 0 1.752.87 1.752 2.292v.006c0 1.41-.673 2.285-1.752 2.285zm5.198 1.143a.826.826 0 00.832-.832.822.822 0 00-.832-.831.824.824 0 00-.838.831c0 .463.368.832.838.832zm5.23 2.26c1.885 0 3.066-1.016 3.066-2.54v-6.493h-1.377v1.136h-.032c-.394-.756-1.13-1.263-2.069-1.263-1.695 0-2.813 1.314-2.813 3.408v.007c0 2.082 1.105 3.396 2.781 3.396.958 0 1.72-.464 2.101-1.187h.032v.914c0 .933-.603 1.517-1.695 1.517-.857 0-1.435-.292-1.619-.717l-.025-.051h-1.359l.007.057c.203 1.022 1.288 1.815 3.002 1.815zm-.057-3.466c-1.085 0-1.765-.864-1.765-2.26v-.007c0-1.377.68-2.253 1.765-2.253 1.041 0 1.746.882 1.746 2.253v.007c0 1.377-.699 2.26-1.746 2.26zm5.001 1.11h1.372v-4.018c0-.945.545-1.536 1.428-1.536.266 0 .508.032.615.076v-1.276c-.107-.019-.279-.05-.476-.05-.787 0-1.383.47-1.587 1.231h-.031v-1.104h-1.321zm6.608.121c.882 0 1.657-.457 2.044-1.174h.025v1.053h1.378v-4.602c0-1.339-1.035-2.202-2.666-2.202-1.644 0-2.641.882-2.736 2.031l-.007.07h1.295l.013-.057c.114-.534.603-.908 1.396-.908.851 0 1.327.444 1.327 1.18v.502l-1.815.108c-1.581.095-2.482.806-2.482 1.968v.013c0 1.2.895 2.018 2.228 2.018zm-.844-2.05v-.013c0-.565.457-.927 1.282-.978l1.631-.101v.52c0 .87-.73 1.524-1.695 1.524-.736 0-1.218-.368-1.218-.952zm6.144 4.151h1.371v-3.345h.031c.394.774 1.162 1.257 2.108 1.257 1.676 0 2.774-1.34 2.774-3.466v-.006c0-2.133-1.092-3.466-2.793-3.466-.952 0-1.689.482-2.089 1.276h-.031v-1.15h-1.371zm3.135-3.269c-1.034 0-1.771-.901-1.771-2.285v-.006c0-1.39.73-2.292 1.771-2.292 1.073 0 1.752.87 1.752 2.292v.006c0 1.41-.673 2.285-1.752 2.285zm4.786 1.047h1.371v-3.865c0-1.041.628-1.765 1.574-1.765.965 0 1.524.66 1.524 1.765v3.865h1.371v-4.126c0-1.612-.94-2.678-2.368-2.678-.996 0-1.714.45-2.069 1.225h-.032v-3.58h-1.371zm8.436-7.706a.79.79 0 100-1.58c-.445 0-.8.355-.8.793 0 .432.355.787.8.787zm-.686 7.706h1.371v-6.677h-1.371zm6.176.134c1.606 0 2.723-1.029 2.869-2.368l.006-.044h-1.32l-.006.05c-.165.724-.705 1.213-1.549 1.213-1.06 0-1.765-.857-1.765-2.317v-.006c0-1.429.692-2.317 1.758-2.317.895 0 1.403.552 1.549 1.206l.013.05h1.308l-.007-.044c-.114-1.257-1.155-2.361-2.875-2.361-1.905 0-3.149 1.34-3.149 3.453v.006c0 2.14 1.219 3.479 3.168 3.479zm6.328-.013c.882 0 1.657-.457 2.044-1.174h.025v1.053h1.378v-4.602c0-1.339-1.035-2.202-2.666-2.202-1.644 0-2.641.882-2.736 2.031l-.007.07h1.295l.013-.057c.114-.534.603-.908 1.397-.908.85 0 1.326.444 1.326 1.18v.502l-1.815.108c-1.581.095-2.482.806-2.482 1.968v.012c0 1.2.895 2.019 2.228 2.019zm-.844-2.05v-.013c0-.565.457-.927 1.282-.978l1.631-.101v.52c0 .87-.73 1.524-1.695 1.524-.736 0-1.218-.368-1.218-.952zm6.924 2.025a.826.826 0 00.832-.832.822.822 0 00-.832-.831.824.824 0 00-.838.831c0 .463.369.832.838.832zm4.621.025c.882 0 1.657-.457 2.044-1.174h.025v1.053h1.378v-4.602c0-1.339-1.035-2.202-2.666-2.202-1.644 0-2.641.882-2.736 2.031l-.006.07h1.294l.013-.057c.114-.534.603-.908 1.397-.908.85 0 1.326.444 1.326 1.18v.502l-1.815.108c-1.581.095-2.482.806-2.482 1.968v.012c0 1.2.895 2.019 2.228 2.019zm-.844-2.05v-.013c0-.565.457-.927 1.282-.978l1.631-.101v.52c0 .87-.73 1.524-1.695 1.524-.736 0-1.218-.368-1.218-.952zm6.886-5.777a.79.79 0 100-1.58.795.795 0 00-.799.793c0 .432.355.787.799.787zm-.685 7.706h1.371v-6.677h-1.371z"
        ></path>
        <rect
          width="7.087"
          height="6.497"
          x="513.33"
          y="19.827"
          fill="#878787"
          rx="1"
        ></rect>
        <g stroke="#878787">
          <path d="M519.17 20.294v-1.961c0-.846-.171-1.717-.753-2.331-.436-.461-.972-.815-1.55-.815-.579 0-1.114.354-1.551.815-.581.614-.753 1.485-.753 2.33v1.962"></path>
          <path
            strokeWidth="1.3"
            d="M1037.3 16.922h1.04c1.11 0 2 .895 2 2v5.908c0 1.104-.89 2-2 2h-7.64c-1.11 0-2-.896-2-2v-5.908c0-1.105.89-2 2-2h1.54"
          ></path>
          <g strokeLinecap="round" strokeWidth="1.3">
            <path d="M1034.8 20.684v-6.581"></path>
            <path
              strokeLinejoin="round"
              d="M1032.7 15.043l2.02-1.88 2.03 1.88"
            ></path>
            <path d="M1068.2 15.187v10.125M1063.1 20.249h10.13"></path>
          </g>
          <rect
            width="10.904"
            height="10.904"
            x="1098.8"
            y="16.433"
            strokeWidth="1.3"
            rx="2"
          ></rect>
          <path
            strokeWidth="1.3"
            d="M1106.4 16.433v-1.271c0-1.105-.89-2-2-2h-6.9c-1.1 0-2 .895-2 2v6.903c0 1.105.9 2 2 2h1.27"
          ></path>
        </g>
        <defs>
          <filter id="lasdnjkw-a" colorInterpolationFilters="sRGB">
            <feBlend in2="BackgroundImage" mode="overlay"></feBlend>
          </filter>
        </defs>
      </svg>
      <MobileFrame className={styles.phone}>{phoneContent}</MobileFrame>
    </div>
  )
}

BrowserScreenWithIPhone.propTypes = {
  className: PropTypes.string,
  browserImageURL: PropTypes.string,
}
